export const menuTypeOption = [
  { label: '目录', value: 'G', rule: ['G'] },
  { label: '菜单', value: 'C', rule: ['G'] },
  { label: '按钮', value: 'F', rule: ['C'] }
]
export const typeOption = [
  { label: '网页端', value: 1 },
  { label: '小程序', value: 2 },
  { label: '客户端', value: 4 }
]
export const isExternalLinkOption = [
  { label: '是', value: 1 },
  { label: '否', value: 0 }
]
export const visibleOption = [
  { label: '显示', value: '1' },
  { label: '隐藏', value: '0' }
]
export const keepaliveOption = [
  { label: '是', value: 1 },
  { label: '否', value: 0 }
]
export const titleOption = {
  add: '新增',
  edit: '编辑'
}
export const typeFieldMapping = {
  G: {
    'icon': undefined, 'menuName': undefined, 'url': undefined, 'component': undefined, 'visible': '1'
  },
  C: { 'menuName': undefined, 'url': undefined, 'component': undefined, 'visible': '1', 'keepalive': 0, 'isExternalLink': 0 },
  F: { 'menuName': undefined, 'perms': undefined, 'visible': '1' }
}
export const iconPrefix = {
  1: 'anticon',
  2: 'iconfont'
}
export const iconOssLocation = {
  1: 'ay230050z-web',
  2: 'ay230050z-mp'
}
